import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  grid: {
    display: 'flex',
    marginLeft: -30,
    width: 'auto',
  },
  gridColumn: {
    paddingLeft: 30,
    backgroundClip: 'padding-box',
    '& > div': {
      marginBottom: 30,
    },
  },
}));
